import EmployerDashboardContent from "./EmployerDashboardContent";
import { CompanyProvider } from "../../context/CompanyContext";

export default function EmployerDashboard() {
    return (
        <CompanyProvider>
            <EmployerDashboardContent />
        </CompanyProvider>
    );
}
